export enum RoomType {
	FAMILY_ROOM = 'FAMILY_ROOM',
	SINGLE_ROOM = 'SINGLE_ROOM',
}

export const ROOM_TYPES = [RoomType.SINGLE_ROOM, RoomType.FAMILY_ROOM];
